export default __webpack_public_path__ + "static/media/assegura2.8f6e03bc.png";